// extracted by mini-css-extract-plugin
export default {"root":"KNSLenkerBlock_root__PCVlm","logo":"KNSLenkerBlock_logo__oIlTN","title":"KNSLenkerBlock_title__U7Axt","links":"KNSLenkerBlock_links__0ZiTo"};